
import React, { useEffect, useState, forwardRef, useRef } from "react";

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import {
    Box, Button, Grid, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HomeIcon from '@mui/icons-material/Home';
import styles from '../../../styles.module.css';
import PurchaseInvoiceList from "../purchaseInvoice/PurchaseInvoiceList";
import PurchaseOrderList from "../purchaseOrder/PurchaseOrderList";
import PurchaseReturnList from "../purchaseReturn/PurchaseReturnList";
import SupplierList from "../supplier/SupplierList";
import PurchaseDashboard from "./PurchaseDashboard";
import Customer_Supplier_PaymentListTab from "../../payments/Customer_Supplier_PaymentListTab";
import { NavLink, useLocation } from "react-router-dom";

const CustomTab = styled(Tab)(({ theme }) => ({
    minWidth: '9px',
    minHeight: '8px',
    marginRight: '6px',
    fontWeight: '400',
    fontSize: '13px',
    color: '#000000',
    borderRadius: '6px 6px 0px 0px',
    border: '1px solid #e6e8eb',
    backgroundColor: '#ffffff',
    padding: '4px 6px 4px 6px',
    margin: '1px 1px 1px 1px',
    letterSpacing: '0.3px',
    wordSpacing: '0.8px',
    textTransform: 'none',
}));


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function PurchaseHome() {
    const location = useLocation()
    const [selectedTab, setSelectedTab] = useState(0);
    const [previousTabs, setPreviousTabs] = useState([]);

    const handleChangeTab = (event, newValue) => {
        setPreviousTabs((prev) => [...prev, selectedTab]);
        setSelectedTab(newValue);
    };

    const handlePreviousTab = () => {
        if (previousTabs.length > 0) {
            const previousTab = previousTabs.pop();
            setSelectedTab(previousTab);
            setPreviousTabs([...previousTabs]);
        }
    };

    return (
        <>
            {/* <Paper className={`${styles.list_container}`}>
                <Box sx={{ width: '100%', padding: '4px', paddingTop: '4px' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxHeight: '28px', paddingLeft: '11px' }}>
                        <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="basic tabs example"
                            indicatorColor="none"
                            textColor="#FFFFFF"

                            variant="scrollable">
                            <CustomTab label="Puchase Home" {...a11yProps(0)} style={selectedTab === 0 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Supplier" {...a11yProps(1)} style={selectedTab === 1 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Purchase Order" {...a11yProps(2)} style={selectedTab === 2 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                            <CustomTab label="Purchase Invoice" {...a11yProps(3)} style={selectedTab === 3 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />

                            <CustomTab label="Supplier Payment" {...a11yProps(4)} style={selectedTab === 4 ? { backgroundColor: '#ff6600', color: 'white' } : {}} />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>

                        <PurchaseDashboard />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <SupplierList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2} >
                        <PurchaseOrderList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={3}>
                        <PurchaseInvoiceList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={4}>
                        <Customer_Supplier_PaymentListTab handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} currentTab={selectedTab} />
                    </TabPanel>
                </Box>
            </Paper> */}
            <Paper style={{ borderRadius: '0px' }}>
                <Box
                    sx={{ overflow: 'auto', whiteSpace: 'nowrap', margin: '10px 10px 20px 10px' }} >
                    {(location.pathname == '/purchase/') ?
                        <NavLink to='/purchase/'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Purchase Home</Button>
                        </NavLink>
                        :
                        <NavLink to='/purchase/'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Purchase Home</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/purchase/supplier') ?
                        <NavLink to='/purchase/supplier'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Supplier</Button>
                        </NavLink>
                        :
                        <NavLink to='/purchase/supplier'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Supplier</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/purchase/purchase-order') ?
                        <NavLink to='/purchase/purchase-order'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Purchase Order</Button>
                        </NavLink>
                        :
                        <NavLink to='/purchase/purchase-order'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }} >Purchase Order</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/purchase/purchase-invoice') ?
                        <NavLink to='/purchase/purchase-invoice'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Purchase Invoice</Button>
                        </NavLink>
                        :
                        <NavLink to='/purchase/purchase-invoice'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Purchase Invoice</Button>
                        </NavLink>
                    }
                    {(location.pathname == '/purchase/supplier-payment') ?
                        <NavLink to='/purchase/supplier-payment'>
                            <Button className={`${styles.tab_active}`} style={{ borderRadius: '8px 8px 0px 0px' }}>Supplier Payment</Button>
                        </NavLink>
                        :
                        <NavLink to='/purchase/supplier-payment'>
                            <Button className={`${styles.tab}`} style={{ borderRadius: '8px 8px 0px 0px' }} >Supplier Payment</Button>
                        </NavLink>
                    }
                </Box>
            </Paper>
        </>
    )
}

export default PurchaseHome;